import React from "react";
import { LocalStorageItem, RoutePath } from "../models/enums";
import { Redirect } from "react-router-dom";

const Navigate: React.FC = (): React.JSX.Element => {
  const [path, setPath] = React.useState<string>("");

  React.useEffect(() => {
    let path: RoutePath = RoutePath.welcomePage;

    if (!localStorage.getItem(LocalStorageItem.licenceAgree)) {
      path = RoutePath.welcomePage;
    } else if (localStorage.getItem(LocalStorageItem.token)) {
      path = RoutePath.conferencePage;
    } else {
      path = RoutePath.loginPage;
    }

    setPath(path);
  }, []);

  if (path) {
    return <Redirect to={path} />;
  }

  return <></>;
};

export default Navigate;
